import { useEffect, useRef, ReactNode } from "react";
import { useLocation } from "react-router-dom";

interface PageTransitionProps {
  children: ReactNode;
}

export default function PageTransition({ children }: PageTransitionProps) {
  const location = useLocation();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.classList.remove("page-animate");
    // Force reflow
    void el.offsetWidth;
    el.classList.add("page-animate");
  }, [location.pathname]);

  return (
    <div ref={ref} className="page-animate">
      {children}
    </div>
  );
}
